import { render, staticRenderFns } from "./fontColorCom.vue?vue&type=template&id=0ccfff0a&scoped=true"
import script from "./fontColorCom.vue?vue&type=script&lang=js"
export * from "./fontColorCom.vue?vue&type=script&lang=js"
import style0 from "./fontColorCom.vue?vue&type=style&index=0&id=0ccfff0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccfff0a",
  null
  
)

export default component.exports